export default "__VITE_ASSET__B05scN8i__"